// src/routes/codeRoutes.jsx
import CodePage from "../pages/CodePage";

const codeRoutes = [
  { path: "/code", element: <CodePage /> },
  // Thêm route con khác nếu cần
];

export default codeRoutes;
